import React from "react";

export const Yantra = ({
    className = "",
    stroke = "#C25934",
    opacity = 0.35,
}) => (
    <svg
        viewBox="0 0 200 200"
        className={className}
        fill="none"
        stroke={stroke}
        strokeWidth="0.6"
        style={{ opacity }}
        aria-hidden="true"
    >
        <circle cx="100" cy="100" r="96" />
        <circle cx="100" cy="100" r="72" />
        <circle cx="100" cy="100" r="46" />
        <circle cx="100" cy="100" r="22" />
        <polygon points="100,20 180,150 20,150" />
        <polygon points="100,180 20,50 180,50" />
        {Array.from({ length: 12 }).map((_, i) => {
            const angle = (i * Math.PI) / 6;
            const x1 = 100 + Math.cos(angle) * 96;
            const y1 = 100 + Math.sin(angle) * 96;
            return <line key={i} x1="100" y1="100" x2={x1} y2={y1} />;
        })}
    </svg>
);

export default Yantra;
